import { CheckUtils } from "./check-utils";
var LinkUtils = /** @class */ (function () {
    function LinkUtils() {
    }
    LinkUtils.getWithExternalLink = function (value) {
        if (CheckUtils.isEmpty(value))
            value = "";
        value = value.replace(/(target=")[^"]*(")/gi, '');
        value = value.replace(/href/gi, 'target="_blank" href');
        return value;
    };
    LinkUtils.asClickable = function (text, selectors, callback) {
        if (CheckUtils.areEmpty(text, selectors, callback))
            return "";
        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString(text, "text/html");
        var nodeList = xmlDoc.querySelectorAll(selectors);
        for (var i = 0; i < nodeList.length; i++) {
            if (!nodeList.item(i).parentElement.hasAttribute("href") ||
                nodeList.item(i).parentNode.childNodes.length > 1) {
                var a = document.createElement("a");
                a.setAttribute("href", callback(nodeList.item(i)));
                nodeList.item(i).parentElement.insertBefore(a, nodeList.item(i));
                a.appendChild(nodeList.item(i));
            }
        }
        return xmlDoc.body.innerHTML;
    };
    LinkUtils.textAsClickable = function (text) {
        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString(text, "text/html");
        LinkUtils.textAsClickableR(xmlDoc.body, xmlDoc.body.childNodes);
        return (xmlDoc.body.innerHTML.
            replace(/&lt;\/a&gt;/gi, "</a>").
            replace(/&lt;a/gi, "<a").
            replace(/&gt;/gi, ">"));
    };
    LinkUtils.textAsClickableR = function (parent, nodeList) {
        for (var i = 0; i < nodeList.length; i++) {
            if (nodeList.item(i).hasChildNodes()) {
                LinkUtils.textAsClickableR(nodeList.item(i), nodeList.item(i).childNodes);
            }
            else if (!parent.hasAttribute("href") || nodeList.length > 1) {
                nodeList.item(i).textContent = nodeList.item(i).textContent.replace(/(((http|ftp)+(s){0,1}:\/\/|WWW)[-a-zA-Z0-9@;:%_+.~#?&\/=]*)/ig, "<a href='\$1'>\$1</a>");
            }
        }
    };
    return LinkUtils;
}());
export { LinkUtils };
//# sourceMappingURL=link-utils.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-utils/link-utils.js
// module id = 986
// module chunks = 14